import gql from 'graphql-tag';

export const HomeRecentActivityQuery = gql`
	query HomeRecentActivityQuery(
		$cloudId: ID!
		$first: Int
		$after: String
		$eventTypes: [String!]
		$objectTypes: [String!]
	) {
		activity {
			myActivity {
				all(
					filter: {
						type: AND
						rootContainerIds: [$cloudId]
						arguments: {
							products: ["CONFLUENCE"]
							objectTypes: $objectTypes
							eventTypes: $eventTypes
						}
					}
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							object {
								id
								data {
									... on ConfluencePage {
										id
										title
										type
										subtype
										pageStatus: status
										links {
											webUi
											editUi
										}
										body {
											excerpt
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										commentCountSummary {
											total
										}
										space {
											id
											alias
											key
											name
										}
										likesSummary {
											count
										}
										editorVersion: properties(keys: ["editor"]) {
											value
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceBlogPost {
										id
										title
										type
										blogStatus: status
										links {
											webUi
											editUi
										}
										body {
											excerpt
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										commentCountSummary {
											total
										}
										space {
											id
											alias
											key
											name
										}
										editorVersion: properties(keys: ["editor"]) {
											value
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceWhiteboard {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
									}
									... on ConfluenceDatabase {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
									}
									... on ConfluenceEmbed {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceInlineComment {
										id
										commentId
										container {
											... on ConfluencePage {
												id
												title
												type
												subtype
												pageStatus: status
												links {
													webUi
													editUi
												}
												body {
													excerpt
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
												likesSummary {
													count
												}
												editorVersion: properties(keys: ["editor"]) {
													value
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceBlogPost {
												id
												title
												type
												blogStatus: status
												links {
													webUi
													editUi
												}
												body {
													excerpt
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
												editorVersion: properties(keys: ["editor"]) {
													value
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceWhiteboard {
												id
												title
												type
												status
												links {
													webUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												space {
													id
													alias
													key
													name
												}
											}
										}
									}
									... on ConfluenceFooterComment {
										id
										commentId
										container {
											... on ConfluencePage {
												id
												title
												type
												subtype
												pageStatus: status
												links {
													webUi
													editUi
												}
												body {
													excerpt
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
												likesSummary {
													count
												}
												editorVersion: properties(keys: ["editor"]) {
													value
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceBlogPost {
												id
												title
												type
												blogStatus: status
												links {
													webUi
													editUi
												}
												body {
													excerpt
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												commentCountSummary {
													total
												}
												space {
													id
													alias
													key
													name
												}
												editorVersion: properties(keys: ["editor"]) {
													value
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceWhiteboard {
												id
												title
												type
												status
												links {
													webUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												space {
													id
													alias
													key
													name
												}
											}
										}
									}
								}
							}
							event {
								timestamp
								eventType
							}
						}
					}
					pageInfo {
						hasNextPage
						endCursor
					}
				}
			}
		}
	}
`;
